import React, { useEffect, useRef, useState } from 'react'
import SectionHeader from '../components/ui/sectionHeader/SectionHeader'
import SectionTitle from '../components/ui/sectionTitle/SectionTitle'
import PrimarySection from '../components/ui/sectionHeader/PrimarySection'
import SecondarySection from '../components/ui/sectionHeader/SecondarySection'
import './getQuoteStyle.scss'
import infoIcon from '../components/ui/planbutton/img/info-icon.svg'
import greenTick from '../components/ui/planbutton/img/greentick.svg'
import PrimaryButton from "../components/ui/button/PrimaryButton";
import { useNavigate, useLocation } from "react-router-dom";
import TextInputSecondary from '../components/ui/input/TextInputSecondary'
import PlanButton from '../components/ui/planbutton/PlanButton'
import SectionBlackLabel from '../components/ui/sectionTitle/SectionBlackLabel'
import { confirmPackage } from '../components/JsonToSoapXml/confirmPackage'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import axios from 'axios'
import ConfirmBox from '../components/modal/ConfirmBox'
import LoadingMask from "../components/loadingMask/LoadingMask";
import SectionLargeTitle from '../components/ui/sectionTitle/SectionLargeTitle.js'
import QuoteToPolicyConvert from '../components/JsonToSoapXml/QuoteToPolicyConvert.js'
import { getValidAccessToken } from '../services/oauthservice.js'
import { isArabic } from '../helpers/commonConstant.js'
import DriverModal from './DriverModal.js'
import { createApiLog, payPremiumApi } from '../helpers/apiLogger.js'
import { updateJourneyLog } from '../helpers/journeyLogger.js'
import OtpModal from './OtpModal.js'
import { isValidOmanMobile } from '../helpers/validation.js'
import { encryptRSA } from '../services/encrypt.js'

export default function GetQuote() {
    const navigate = useNavigate();
    const dispatch = useDispatch()

    const processedTransId = useRef(null);
    const [formData, setFormData] = useState({ mobileNo: '85318036', whatsapp: '', email: '', termsCondition: false })
    const location = useLocation();
    const { partnerDetail } = useSelector((state) => state.domainReducer)
    const { PARTNER_ID } = partnerDetail
    const [quoteInfo, setQuoteInfo] = useState(() => location.state || {});
    const [showModal, setShowModal] = useState(false);
    const [errMessage, setErrMessage] = useState('')
    const [promoPayment, setPromoPayment] = useState()
    const [isPromoCodeApplied, setIsPromoCodeApplied] = useState(false)
    const [showDriverModal, setShowDriverModal] = useState(false)
    const [otpVerified, setOtpVerified] = useState(false);
    const [otpSent, setOtpSent] = useState(false);
    const [openOtpModal, setOpenOtpModal] = useState(false);
    const [otpResult, setOtpResult] = useState(false);
    const { loading } = useSelector(state => state.loadingReducer);
    const { partnerConfig } = useSelector((state) => state.partnerConfig || {});
    const { SHOW_PROMO_CODE = 1, SHOW_MULTIPLE_PLANS = 1, SRC_BUS_ID = 'CP', JOURNEY_ID, APP_ID, JOURNEY_CODE } = partnerConfig || {};
    const { partnerSmsConfig } = useSelector((state) => state.partnerSmsConfig || {});
    const { IS_EMAIL_MANDATORY, EMAIL_DOMAIN } = partnerSmsConfig

    const { carName,
        modelName,
        modelYear,
        plateNumber,
        plateCode,
        chassisNo,
        bodyType,
        usageType,
        vehicleValue,
        insuredName,
        civilId,
        age,
        quoteNo,
        coverFromDate,
        coverToDate,
        product,
        packages,
        isRenewPolicy = false,
        mobileNo,
        eMailId,
        whatsappNo,
        prodId,
        policyNo = '',
        previousPolicyNo = '',
        isTransConfirmPlan = false } = quoteInfo

    const isShowPayPremium = !SHOW_MULTIPLE_PLANS || quoteInfo.status === 'Y' || isRenewPolicy
    const isShowConfirmPlan = SHOW_MULTIPLE_PLANS && quoteInfo.status !== 'Y' && !isRenewPolicy
    const isSkipPayment = process.env.REACT_APP_IS_SKIP_PAYMENT === "true";

    useEffect(() => {
        if (Object.keys(quoteInfo).length === 0) {
            navigate("/");
        }
    }, [quoteInfo, navigate]);

    const handleCommunicationPref = async () => {

        if (IS_EMAIL_MANDATORY === 1 && quoteInfo.eMailId === '') {
            setErrMessage(
                'Please provide your communication preference.<br/>To receive policy document and related communication, please provide Email.'
            );
            setShowModal(true);
            return false;
        }

        if (quoteInfo.whatsappNo === '' && quoteInfo.eMailId === '') {
            setErrMessage(
                'Please provide your communication preference.<br/>To receive policy document and related communication, please provide WhatsApp number or Email.'
            );
            setShowModal(true);
            return false;
        }

        const request = {
            licenseNo: civilId,
            quoteNo: quoteNo,
            agentCode: null,
            emailYN: eMailId ? 'Y' : 'N',
            emailId: eMailId ? eMailId : null,
            smsYN: mobileNo ? 'Y' : 'N',
            mobileCountry: mobileNo ? '968' : null,
            mobileNo: mobileNo ? mobileNo : null,
            whatsappYN: whatsappNo ? 'Y' : 'N',
            whatsappCountry: whatsappNo ? '968' : null,
            whatsappNo: whatsappNo ? whatsappNo : null
        }
        const token = await getValidAccessToken();
        const encrypted = await encryptRSA(request)
        try {
            dispatch({ type: "LOADING", payload: true });
            const response = await axios.post(
                `${process.env.REACT_APP_DIC_ADMIN_API}/v1/motor/quotes/internal-communication-preferences`,
                { encrypted }, // axios automatically stringifies JSON
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            await createApiLog({
                PARTNER_ID: PARTNER_ID,
                APP_ID: 1,
                COB: "MOTOR",
                TRANS_ID: quoteInfo?.transId,
                API: `${process.env.REACT_APP_DIC_ADMIN_API}/v1/motor/quotes/internal-communication-preferences`,
                REQUEST: request,
                REQUEST_STATUS: "Success",
                RESPONSE: response,
            })

            await updateJourneyLog({
                TRANS_ID: quoteInfo?.transId,
                JOURNEY_STATUS: "CP_UPDATED",
                REMARKS: ''
            })

            dispatch({ type: "LOADING", payload: true });
            dispatch({ type: "LOADING", payload: true });
            return response
        } catch (error) {
            console.error('Error posting data:', error);
            dispatch({ type: "LOADING", payload: true });
            await createApiLog({
                PARTNER_ID: PARTNER_ID,
                APP_ID: 1,
                COB: "MOTOR",
                TRANS_ID: quoteInfo?.transId,
                API: `${process.env.REACT_APP_DIC_ADMIN_API}/v1/motor/quotes/internal-communication-preferences`,
                REQUEST: request,
                REQUEST_STATUS: "Error",
                RESPONSE: error,
            })
            dispatch({ type: "LOADING", payload: true });
        }

    }

    const handleConfirmPlan = async () => {
        const soapRequest = confirmPackage({ ...quoteInfo, srcBusId: SRC_BUS_ID });
        await updateJourneyLog({
            TRANS_ID: quoteInfo?.transId,
            JOURNEY_STATUS: "PLAN_SELECTED",
            REMARKS: ''
        })
        try {
            dispatch({ type: "LOADING", payload: true });
            const response = await fetch(`${process.env.REACT_APP_CONFIRM_PACKAGE}`, {
                method: "POST",
                headers: {
                    "Content-Type": "text/xml",
                },
                body: soapRequest,
            });

            const textResponse = await response.text();

            await createApiLog({
                PARTNER_ID: PARTNER_ID,
                APP_ID: 1,
                COB: "MOTOR",
                TRANS_ID: quoteInfo?.transId,
                API: process.env.REACT_APP_CONFIRM_PACKAGE,
                REQUEST: soapRequest,
                REQUEST_STATUS: "Success",
                RESPONSE: textResponse,
            })

            await updateJourneyLog({
                TRANS_ID: quoteInfo?.transId,
                JOURNEY_STATUS: "SELECTED_PLAN_UPDATED",
                REMARKS: ''
            })

            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(textResponse, "text/xml");

            // Extract errMsg
            const errMsgNode = xmlDoc.getElementsByTagName("errMsg")[0];
            if (errMsgNode) {
                alert(errMsgNode.textContent.trim());
                return;
            }

            // Extract status
            const statusNodes = xmlDoc.getElementsByTagName("status");
            let extractedStatus = null;

            for (let i = 0; i < statusNodes.length; i++) {
                const statusNode = statusNodes[i].getElementsByTagName("status")[0]; // Find nested <status>
                if (statusNode) {
                    extractedStatus = statusNode.textContent.trim();
                    break; // Stop after finding the first valid <status>
                }
            }

            if (extractedStatus === "Y") {
                // Find package by packageId
                const selectedPackage = quoteInfo.packages.find(pkg => pkg.planId === quoteInfo.packageId);

                if (selectedPackage) {
                    // Update quoteInfo with package details
                    const newQuoteInfo = {
                        ...quoteInfo,
                        status: "Y",
                        plan: selectedPackage.plan,
                        planId: selectedPackage.planId,
                        premiumAmt: selectedPackage.premiumAmt,
                        coverage: selectedPackage.coverage,
                        isValid: true
                    }

                    return newQuoteInfo
                }
            }
        } catch (error) {
            console.error("Error:", error);

            await createApiLog({
                PARTNER_ID: PARTNER_ID,
                APP_ID: 1,
                COB: "MOTOR",
                TRANS_ID: quoteInfo?.transId,
                API: process.env.REACT_APP_CONFIRM_PACKAGE,
                REQUEST: soapRequest,
                REQUEST_STATUS: "Error",
                RESPONSE: error,
            })

            return { isValid: false }
        }
    };

    const createMotorQuotes = async () => {

        const data = {
            partnerId: PARTNER_ID,
            journeyId: 1,
            transId: quoteInfo?.transId,
            quoteNo: quoteNo,
            quoteStatus: 'QUOTE_GENERATED',
            paymentStatus: '',
            journeyCode: JOURNEY_CODE
        }

        try {
            const token = await getValidAccessToken()
            const encrypted = await encryptRSA(data)
            const response = await axios.post(`${process.env.REACT_APP_DIC_ADMIN_API}/v1/motor/quotes`, { encrypted },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

            await createApiLog({
                PARTNER_ID: PARTNER_ID,
                APP_ID: 1,
                COB: "MOTOR",
                TRANS_ID: quoteInfo?.transId,
                API: `${process.env.REACT_APP_DIC_ADMIN_API}/v1/motor/quotes`,
                REQUEST: data,
                REQUEST_STATUS: "Success",
                RESPONSE: response,
            })

            return response.data
        } catch (error) {
            console.error('Error posting data:', error);

            await createApiLog({
                PARTNER_ID: PARTNER_ID,
                APP_ID: 1,
                COB: "MOTOR",
                TRANS_ID: quoteInfo?.transId,
                API: `${process.env.REACT_APP_DIC_ADMIN_API}/v1/motor/quotes`,
                REQUEST: data,
                REQUEST_STATUS: "Failed",
                RESPONSE: error,
            })
        }
    }

    useEffect(() => {
        const fetchQuotes = async () => {
            if (quoteInfo?.transId && processedTransId.current !== quoteInfo.transId) {
                processedTransId.current = quoteInfo.transId; // mark as processed
                await createMotorQuotes();
            }
        };

        fetchQuotes();
    }, [quoteInfo?.transId]);

    const updateMotorQuotes = async (premiumAmt) => {

        const data = {
            quoteNo: quoteNo,
            sendSms: mobileNo ? 1 : 0,
            mobileNoCountryCode: 968,
            mobileNo: mobileNo,
            sendWhatsapp: whatsappNo ? 1 : 0,
            sameAsMobileNo: mobileNo === whatsappNo ? 1 : 0,
            whatsappNoCountryCode: 968,
            whatsappNo: whatsappNo,
            sendEmail: eMailId ? 1 : 0,
            email: eMailId,
            selectedPlan: quoteInfo?.plan,
            premium: premiumAmt,
            promoCodeApplied: isPromoCodeApplied ? 1 : 0,
            promoCode: quoteInfo?.promoCode,
            discount: promoPayment?.promoDiscountAmount,
            discountedPremium: promoPayment?.netPayablePremium,
            paymentStatus: ''
        }

        try {
            const token = await getValidAccessToken()
            const encrypted = await encryptRSA(data)
            const response = await axios.put(`${process.env.REACT_APP_DIC_ADMIN_API}/v1/motor/quotes`, { encrypted },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

            await createApiLog({
                PARTNER_ID: PARTNER_ID,
                APP_ID: 1,
                COB: "MOTOR",
                TRANS_ID: quoteInfo?.transId,
                API: `${process.env.REACT_APP_DIC_ADMIN_API}/v1/motor/quotes`,
                REQUEST: data,
                REQUEST_STATUS: "Success",
                RESPONSE: response,
            })

            return response.data
        } catch (error) {
            console.error('Error posting data:', error);

            await createApiLog({
                PARTNER_ID: PARTNER_ID,
                APP_ID: 1,
                COB: "MOTOR",
                TRANS_ID: quoteInfo?.transId,
                API: `${process.env.REACT_APP_DIC_ADMIN_API}/v1/motor/quotes`,
                REQUEST: data,
                REQUEST_STATUS: "Failed",
                RESPONSE: error,
            })
        }
    }

  const handlePayPremium = async () => {
  dispatch({ type: "LOADING", payload: true });
  try {
    const userInfo = {
      civilId,
      insuredName,
      mobileNo,
      plateNo: plateNumber,
      plateRegType: 1,
      product,
      plateCode,
    };

    const result = await payPremiumApi({
      ...quoteInfo,

      partnerId: PARTNER_ID,
      appId: APP_ID,
      journeyId: JOURNEY_ID,

      mobileNo,
      whatsappNo,
      eMailId,

      promoPayment,

      isPromoCodeApplied,
      isShowConfirmPlan,
      isTransConfirmPlan,

      userInfo,
    });

    const premiumAmt =
      result?.result?.premiumAmt ||
      quoteInfo?.premiumAmt;

    const quoteNo = quoteInfo.quoteNo;

    const amount =
      promoPayment?.netPayablePremium ||
      premiumAmt;

    const token = await getValidAccessToken();

    const requestData = {
      quoteNo,
      amount,
      partnerId: PARTNER_ID,
      appId: APP_ID,
      journeyId: JOURNEY_ID,
      transId: quoteInfo?.transId,
      userInfo
    };

    const encrypted =
      await encryptRSA(requestData);

    const response = await axios.post(
      `${process.env.REACT_APP_DIC_ADMIN_API}/v1/payments/internal-payment-links`,
      { encrypted },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    const paymentUrl =
      response.data.data;

    await updateJourneyLog({
      TRANS_ID: quoteInfo?.transId,
      JOURNEY_STATUS: "PAYMENT_INITIATED",
      REMARKS: ""
    });

    window.location.href = paymentUrl;
  } catch (error) {
    console.error(
      "Error during payment initiation:",
      error
    );

    setErrMessage(
      "Failed to process the payment request."
    );

    setShowModal(true);
  } finally {
    dispatch({
      type: "LOADING",
      payload: false,
    });
  }
};

    const handlePaymentSuccessful = async () => {
        const responseData = { order_status: 'Successful', amount: promoPayment?.netPayablePremium ? promoPayment.netPayablePremium : quoteInfo.premiumAmt, payment_id: '12345670', mer_param_2: quoteInfo.quoteNo }
        const soapRequest = QuoteToPolicyConvert({ ...responseData, srcBusId: SRC_BUS_ID })
        try {
            const response = await fetch(`${process.env.REACT_APP_QUOTE_TO_POLICY}`, {
                method: "POST",
                headers: {
                    "Content-Type": "text/xml",
                },
                body: soapRequest,
            });
            const query = new URLSearchParams(response).toString();
            navigate(`/payment-successful?${query}`);
        } catch (error) {
            navigate('/payment-unsuccessful')
            return null;
        }
    }

    const handleBypassPaypremium = async () => {
        if (isSkipPayment) {
            handlePaymentSuccessful()
        } else {
            handlePayPremium()
        }
    }

    const handleChange = (e) => {
        setQuoteInfo({ ...quoteInfo, [e.target.name]: e.target.value });
    };

    const handleOncheckbox = (e) => {
        setFormData({ ...formData, termsCondition: e.target.checked });
    };

    const handleSelectPlan = (packageId, premiumAmt, plan) => {
        setQuoteInfo((prevData) => ({
            ...prevData,
            packageId,
            plan,
            premiumAmt
        }));


    };

    const handleCloseConfirm = () => {
        setErrMessage('')
        setShowModal(false)
    }

    const handleSameNumber = (istrue) => {
        if (istrue) {
            setQuoteInfo({ ...quoteInfo, whatsappNo: quoteInfo.mobileNo });
        } else {
            setQuoteInfo({ ...quoteInfo, whatsappNo: '' });
        }
    }

    const handlePromoCode = async () => {
        setIsPromoCodeApplied(true)

        // const updateCommunication = await handleCommunicationPref()
        // if (!updateCommunication) {
        //     return
        // }

        if (isShowConfirmPlan && !isTransConfirmPlan) {
            const confirmPlan = await handleConfirmPlan(); // Assuming this is synchronous

            if (!confirmPlan?.isValid) {
                setErrMessage('Failed to process the payment request.')
                setShowModal(true)
                dispatch({ type: "LOADING", payload: false });
                return;
            }

            setQuoteInfo(confirmPlan)
        }

        const { promoCode, quoteNo } = quoteInfo
        const request = { promoCode: promoCode, quoteNo: quoteNo, srcBusId: "TABADUL" }
        const token = await getValidAccessToken();
        const encrypted = await encryptRSA(request)
        try {
            dispatch({ type: "LOADING", payload: true });
            const response = await axios.post(
                `${process.env.REACT_APP_DIC_ADMIN_API}/v1/motor/quotes/internal-apply-promo-code`,
                { encrypted }, // axios automatically stringifies JSON
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            await createApiLog({
                PARTNER_ID: PARTNER_ID,
                APP_ID: 1,
                COB: "MOTOR",
                TRANS_ID: quoteInfo?.transId,
                API: `${process.env.REACT_APP_DIC_ADMIN_API}/v1/motor/quotes/internal-apply-promo-code`,
                REQUEST: request,
                REQUEST_STATUS: "Success",
                RESPONSE: response,
            })

            await updateJourneyLog({
                TRANS_ID: quoteInfo?.transId,
                JOURNEY_STATUS: "PROMO_CODE_APPLIED",
                REMARKS: ''
            })

            const { data } = response.data
            setPromoPayment(data)
            dispatch({ type: "LOADING", payload: false });

        } catch (error) {
            dispatch({ type: "LOADING", payload: false });
            setErrMessage(error.error);
            setShowModal(true);

            await createApiLog({
                PARTNER_ID: PARTNER_ID,
                APP_ID: 1,
                COB: "MOTOR",
                TRANS_ID: quoteInfo?.transId,
                API: `${process.env.REACT_APP_DIC_ADMIN_API}/v1/motor/quotes/internal-apply-promo-code`,
                REQUEST: request,
                REQUEST_STATUS: "Error",
                RESPONSE: error,
            })

            console.error('Error posting data:', error);
        }
    }

    const validateOtpInputs = (quoteInfo, EMAIL_DOMAIN, IS_EMAIL_MANDATORY) => {
        const { isValid } = isValidOmanMobile(quoteInfo.mobileNo);

        // 1️⃣ Check email domain if required
        if (EMAIL_DOMAIN) {
            const emailDomain = quoteInfo.eMailId?.split("@")[1]?.toLowerCase();

            if (!emailDomain) {
                return "Invalid email format.";
            }

            if (emailDomain !== EMAIL_DOMAIN.toLowerCase()) {
                return `Email domain mismatch. Expected: ${EMAIL_DOMAIN}`;
            }
        }

        // 2️⃣ Check email mandatory
        if (!isValid || (IS_EMAIL_MANDATORY === 1 && !quoteInfo.eMailId)) {
            return `Please provide your communication preference.<br/>
                To receive policy document and related communication, please provide Email.`;
        }

        // 3️⃣ Check either WhatsApp or Email required
        if (!isValid || (!quoteInfo.whatsappNo && !quoteInfo.eMailId)) {
            return `Please provide your communication preference.<br/>
                To receive policy document and related communication, please provide WhatsApp number or Email.`;
        }

        // ✅ All good
        return null;
    };

    const sendOtp = async () => {
        const token = await getValidAccessToken();

        try {
            dispatch({ type: "LOADING", payload: true });

            // Run validation before sending OTP
            const validationError = validateOtpInputs(quoteInfo, EMAIL_DOMAIN, IS_EMAIL_MANDATORY);

            if (validationError) {
                setErrMessage(validationError);
                setShowModal(true);
                return;
            }

            const request = {
                channel: IS_EMAIL_MANDATORY === 1 ? 'email' : 'sms',
                destination: IS_EMAIL_MANDATORY === 1 ? quoteInfo.eMailId : quoteInfo.mobileNo,
                partnerId: partnerDetail?.PARTNER_ID
            }
            const encrypted = await encryptRSA(request)
            const response = await fetch(
                `${process.env.REACT_APP_DIC_ADMIN_API}/v1/otp/internal-send`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`
                    },
                    body: JSON.stringify({ encrypted }),
                }
            );

            const result = await response.json();
            const otpResult = result?.data?.[0];

            if (result.success) {
                setOtpSent(true);
                setOpenOtpModal(true);
                setOtpResult(otpResult);
            } else {
                const errMsg =
                    otpResult?.status === "Failed"
                        ? "Failed to send OTP. Please try again."
                        : "Something went wrong while sending OTP.";

                setErrMessage(errMsg);
                setShowModal(true);
            }
        } catch (error) {
            console.error("Error sending OTP:", error);
            setErrMessage("Unexpected error occurred while sending OTP.");
            setShowModal(true);
        } finally {
            dispatch({ type: "LOADING", payload: false });
        }
    };



    const handleVerified = async () => {
        setOtpVerified(true)
        setOpenOtpModal(false)
        await handleCommunicationPref()
        dispatch({ type: "LOADING", payload: false });
    }

    return (
        <>
            {loading && <LoadingMask />}

            <ConfirmBox
                show={showModal}
                message={errMessage}
                onCancel={handleCloseConfirm} />

            <DriverModal
                show={showDriverModal}
                handleClose={() => setShowDriverModal(false)}
                quoteNo={quoteNo}
            />
            {console.log('eMailId', eMailId)}
            {openOtpModal && <OtpModal
                show={openOtpModal}
                handleClose={() => setOpenOtpModal(false)}
                formData={{ mobileNo, eMailId, ...otpResult }}
                handleVerified={() => handleVerified()}
                sendOtp={() => sendOtp()}
            />}

            <div className="container">
                {/* Section Header */}
                <div className="row mb-1">
                    <div className="col-md-12">
                        <SectionHeader title="Motor Insurance " stepNo={2} totalStep={3} />
                    </div>
                </div>
                {partnerDetail?.LOGO && <div className="container bg-white">
                    <div className="row mt-2 mb-1">
                        <div className="col-md-12 mt-2 mb-2 d-flex justify-content-center">
                            <img src={partnerDetail?.LOGO} style={{ height: '65px' }} alt="partnerlogo" />
                        </div>
                    </div>
                </div>}
                <div className="container bg-white">
                    <div className="row mt-2">
                        <div className="col-md-12 mt-3 ms-4">
                            <SectionLargeTitle title="Quote Summary" />
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    {/* Vehicle Card */}
                                    <div className="card shadow">
                                        <div className="card-body">
                                            <SectionTitle title="Vehicle" />
                                            <PrimarySection>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <label className='vehicle-bold-label'>{carName} {modelName}</label>
                                                        <br />
                                                        <label className='vehicle-year mt-2'>{modelYear}</label>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <SecondarySection className='d-flex justify-content-center secondary-section-border'>
                                                            <label className='plate-number'>{plateNumber} {plateCode}</label>
                                                        </SecondarySection>
                                                    </div>
                                                </div>
                                            </PrimarySection>
                                            <div className="row mt-3">
                                                <div className="col-md-6">
                                                    <div className="col-md-12 mt-2">
                                                        <p className="grey-quote-label mb-1">Chassis Number</p>
                                                        <p className="black-value mt-0 mb-3">{chassisNo}</p>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <p className="grey-quote-label mb-1">Usage Type</p>
                                                        <p className="black-value mt-0 mb-3">{usageType}</p>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="col-md-12 mt-2">
                                                        <p className="grey-quote-label mb-1">Body Type</p>
                                                        <p className="black-value mt-0 mb-3">{bodyType}</p>
                                                    </div>
                                                    <div className="col-md-12">
                                                        {prodId !== '0502' && <><p className="grey-quote-label mb-1">Vehicle Value</p>
                                                            <p className="black-value mt-0 mb-3">{vehicleValue}</p></>}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Insured Card */}
                                    <div className="card shadow mt-3">
                                        <div className="card-body">
                                            <SectionTitle title="Insured" />
                                            <div className="row mt-3">
                                                <div className="col-md-12">
                                                    <div className="col-md-12 mt-2">
                                                        <p className="insured-label mb-1">Insured Name</p>
                                                        <p
                                                            className="black-value mt-0 mb-3"
                                                            dir={isArabic(insuredName) ? "rtl" : "ltr"}
                                                            style={{ textAlign: "left" }}
                                                        >
                                                            {insuredName}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="row">
                                                        <div className="col-md-6 mt-2">
                                                            <p className="insured-label mb-1">Civil Id</p>
                                                            <p className="black-value mt-0 mb-3">{civilId}</p>
                                                        </div>
                                                        <div className="col-md-6 mt-2">
                                                            <p className="insured-label mb-1">Age</p>
                                                            <p className="black-value mt-0 mb-3">{age}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <PrimaryButton
                                                        label="Add Driver"
                                                        onClick={() => setShowDriverModal(true)}
                                                    />
                                                </div>
                                                <div className='col-md-8'>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card shadow mt-3">
                                        <div className="card-body">
                                            <SectionTitle title="Communication Preferences" />
                                            <div className="row mt-3">
                                                <p className='communication-header'>Your Communication Preferences and Consent</p>
                                                <p className='communication-content'>
                                                    Please select how you’d like to receive policy documents and communications.
                                                    By choosing your preferred mode, you consent to receiving documents and related updates electronically.
                                                    You can update these preferences anytime.
                                                    Preferred Communication Mode (I consent for receiving policy documents,
                                                    related updates and communications electronically)
                                                </p>
                                            </div>

                                            <div className='row'>
                                                <div className='col-md-6'>
                                                    <TextInputSecondary
                                                        label="Mobile Number"
                                                        name="mobileNo"
                                                        type="text"
                                                        value={mobileNo}
                                                        onChange={handleChange}
                                                        placeholder="Enter your mobile number"
                                                        required
                                                        requiredMsg="Please enter a valid Mobile number"
                                                        isFieldChecked={true}
                                                        disabled={otpVerified}
                                                    />
                                                </div>
                                                <div className='col-md-6'>
                                                    <TextInputSecondary
                                                        label="Whatsapp"
                                                        name="whatsappNo"
                                                        type="text"
                                                        value={whatsappNo}
                                                        onChange={handleChange}
                                                        placeholder="Enter your whatsapp"
                                                        required
                                                        requiredMsg="Please enter a valid Whatsapp number"
                                                        isSecondaryCheck={true}
                                                        handleSecondaryCheck={handleSameNumber}
                                                        secondaryCheckText='Same as Mobile No'
                                                        disabled={otpVerified}
                                                    />
                                                </div>
                                                <div className='col-md-6'>
                                                    <TextInputSecondary
                                                        label="Email"
                                                        name="eMailId"
                                                        type="email"
                                                        value={eMailId}
                                                        onChange={handleChange}
                                                        placeholder="Enter your email"
                                                        disabled={otpVerified}
                                                    />
                                                </div>
                                                <div className="col-md-6 d-flex justify-content-center align-items-center">
                                                    {!otpVerified && (
                                                        <div className="d-flex justify-content-center align-items-center w-100 mt-3">
                                                            <PrimaryButton
                                                                label="Send OTP"
                                                                onClick={sendOtp}
                                                                id="send-otp"
                                                                className="w-auto"
                                                            />
                                                        </div>
                                                    )}

                                                    {otpVerified && (
                                                        <div className="text-success fw-bold d-flex align-items-center mt-3">
                                                            <img
                                                                src={greenTick}
                                                                alt="Success"
                                                                className="me-2"
                                                                style={{ width: "24px" }}
                                                            />
                                                            OTP Verified Successfully
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <div className="col-md-6 mb-3">
                                    <div className="card shadow">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <SectionTitle title="Quote" />
                                                </div>
                                            </div>
                                            <div className="row mt-3">
                                                <div className="col-md-6 mt-2">
                                                    <p className="grey-quote-label mb-1">Quote No</p>
                                                    <p className="black-value mt-0 mb-3">{quoteNo}</p>
                                                </div>
                                                {previousPolicyNo && <div className="col-md-6 mt-2">
                                                    <p className="grey-quote-label mb-1">Old Policy No</p>
                                                    <p className="black-value mt-0 mb-3">{previousPolicyNo}</p>
                                                </div>}
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="row">
                                                        <div className="col-md-6 mt-2">
                                                            <p className="grey-quote-label mb-1">Cover From Date</p>
                                                            <p className="black-value mt-0 mb-3">{coverFromDate.slice(0, 16)}</p>
                                                        </div>
                                                        <div className="col-md-6 mt-2">
                                                            <p className="grey-quote-label mb-1">Cover To Date</p>
                                                            <p className="black-value mt-0 mb-3">{coverToDate.slice(0, 16)}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mt-3">
                                                <div className="col-md-12">
                                                    <div className="col-md-12 mt-2">
                                                        <p className="grey-quote-label mb-1">Product</p>
                                                        <p className="black-value mt-0 mb-3">{product}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mt-3">
                                                <div className="col-md-12">
                                                    <div className="col-md-12 mt-2">
                                                        {isShowPayPremium &&
                                                            <>
                                                                <p className="grey-quote-label mb-1">Plan</p>
                                                                <SecondarySection className='plan-padding mt-2'>
                                                                    <div className='d-flex justify-content-between align-items-center'>
                                                                        <span className='plan-text'>
                                                                            {quoteInfo.plan}
                                                                            <OverlayTrigger
                                                                                placement="top"
                                                                                overlay={<Tooltip
                                                                                    id="tooltip"
                                                                                    html
                                                                                >
                                                                                    <div className='tooltip-div' dangerouslySetInnerHTML={{ __html: quoteInfo.coverageList }} />
                                                                                </Tooltip>
                                                                                }
                                                                            >
                                                                                <img src={infoIcon} alt='infoicon' />
                                                                            </OverlayTrigger>
                                                                        </span>
                                                                        <span className='plan-cost'>
                                                                            OMR {Number(quoteInfo.premiumAmt).toFixed(3)} <img src={greenTick} alt='infoicon' />
                                                                        </span>
                                                                    </div>
                                                                </SecondarySection>
                                                            </>}
                                                        {isShowConfirmPlan ?
                                                            <>
                                                                <SectionBlackLabel title="Select Plan" />
                                                                <div className="d-grid gap-3 mb-3">
                                                                    {Array.isArray(packages) && Boolean(packages?.length) && packages.map((plan) => (
                                                                        <>
                                                                            <PlanButton
                                                                                key={plan.planId} // Use a unique key
                                                                                text={plan.plan}
                                                                                infoText={plan.coverageList}
                                                                                onClick={() => handleSelectPlan(plan.planId, plan.premiumAmt, plan.plan)}
                                                                                isActive={quoteInfo.packageId === plan.planId}
                                                                                isAmount={true}
                                                                                amount={Number(plan.premiumAmt).toFixed(3)}
                                                                            />
                                                                        </>
                                                                    ))}
                                                                </div>
                                                            </> : null}
                                                    </div>
                                                </div>
                                            </div>
                                            {quoteInfo?.premiumAmt &&
                                                <div className="row mt-3">
                                                    <div className="col-md-12">
                                                        <input className="form-check-input" type="checkbox" id="customCheck" checked={formData.termsCondition} onChange={handleOncheckbox} />
                                                        <label className="form-check-label ms-2" htmlFor="customCheck">
                                                            I accept the &nbsp;
                                                            <a href='https://dhofarinsurance.com/privacy-policy/'>
                                                                <span class='text-decoration-underline'>
                                                                    Privacy Policy
                                                                </span>
                                                            </a>
                                                        </label>
                                                    </div>
                                                </div>
                                            }
                                            {SHOW_PROMO_CODE ?
                                                <>
                                                    <div className="row mt-3">
                                                        <div className="col-md-12">
                                                            <p className="grey-quote-label mb-1">Enter Promo Code</p>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-7 mb-2">
                                                            <input
                                                                type="text"
                                                                class="form-control"
                                                                id="promoCode1"
                                                                name="promoCode"
                                                                onChange={handleChange}
                                                                placeholder="Promo Code"></input>
                                                        </div>
                                                        <div className="col-md-5">
                                                            <button type="button" class="promo-btn" onClick={handlePromoCode} disabled={!quoteInfo?.promoCode}>Apply Promo Code</button>
                                                        </div>
                                                        <div className="col-md-1"></div>
                                                    </div>
                                                </> : null}
                                        </div>
                                    </div>
                                    {quoteInfo?.premiumAmt &&
                                        <SecondarySection className='plan-padding mt-2'>
                                            <div className="row d-flex align-items-center ms-1 me-1">
                                                <div className="col-md-7">
                                                    <label className='net-premium-label'>NET PREMIUM <span className='include-label'>(Including VAT & all other taxes)</span></label>
                                                    <br />
                                                    {promoPayment?.netPayablePremium ? (
                                                        <>
                                                            <label className='pay-cost text-decoration-line-through text-red-500 me-2'>
                                                                OMR {Number(quoteInfo.premiumAmt).toFixed(3)}
                                                            </label>
                                                            <label className='pay-cost text-green-600 font-bold'>
                                                                OMR {Number(promoPayment.netPayablePremium).toFixed(3)}
                                                            </label>
                                                        </>
                                                    ) : (
                                                        <label className='pay-cost'>
                                                            OMR {Number(quoteInfo.premiumAmt).toFixed(3)}
                                                        </label>
                                                    )}
                                                </div>
                                                <div className="col-md-5">
                                                    <PrimaryButton label="PAY PREMIUM" onClick={handleBypassPaypremium} disabled={!(formData.termsCondition && otpVerified)} />
                                                </div>
                                            </div>
                                        </SecondarySection>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                    </div>
                </div>
            </div>
        </>
    )
}
